
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 9c4.142 0 7.5 1.567 7.5 3.5V15H0v-2.5C0 10.567 3.358 9 7.5 9zm6.5 3.5c0-1.38-2.91-2.5-6.5-2.5S1 11.12 1 12.5V14h13v-1.5zM7.5 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5z","fill":"#000"}})])
          )
        }
      }
    